import React from 'react';
import accountSummaryCss from "../../../styles/myAccount/accountSummary.module.scss";

const NoServiceAgreement = ({noPlansServices}) => {
    return (
      <div className='mma--year-error row'>
          <div className='col-12'>
            <div className={`row mb-16 ${accountSummaryCss["tru-mma-main-content-box"]}`}>
              <div className={`col-12 gfw-3 p-30 text-center text-md-left ${accountSummaryCss["tru-mma-main-content"]}`}>
                <div className='align-items-center row'>
                  <div className='col-md-2'>
                    <img src='/images/MyAccount/Icons/error-notification-icon.png' className='img-fluid' alt='Error Notification' />
                  </div>
                  <div className='col-md-10'>
                    <span className={`d-block ${accountSummaryCss["gfs-24"]} ${accountSummaryCss["gfs-lg-30"]} ${accountSummaryCss["gfw-3"]} ${accountSummaryCss["glh-1_2"]} ${accountSummaryCss["mb-10"]}`}>
                      {noPlansServices}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
}

export default NoServiceAgreement;
